import React, { useState, useRef, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "react-router-dom";
import fundnest_icon from "../assets/fund-nest-icon.png";
import { Slide, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from 'react-i18next';

const languages = [
  { code: "en", name: "English", flag: "us" },
  { code: "es", name: "Spanish", flag: "es" },
  { code: "fr", name: "French", flag: "fr" },
  { code: "de", name: "German", flag: "de" },
  { code: "it", name: "Italian", flag: "it" },
]
const Navbar = ({ onLanguageChange }) => {
  const isXs = useMediaQuery("(min-width:768px) and (max-width:3000px)");
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(languages.filter(l => l.code == i18n.language.split('-')[0] ?? 'en')[0]);
  const [isLanOpen, setIsLanOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openNew, setIsOpenNew] = useState(false);

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    setIsLanOpen(false);
    // console.log(language.code)
    i18n.changeLanguage(language.code);
    if (onLanguageChange) {
      onLanguageChange(language.code);
    }
  };

  const toggleLanguageDropdown = () => {
    setIsLanOpen(!isLanOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsLanOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const toggleDrawer = () => {
    setIsOpenNew(!openNew);
  };

  const dropdownStyles = {
    position: "relative",
    display: "inline-block",
  };
  const mobileDropdownStyles = {
    position: "relative",
    display: "inline-block",
    padding: "10px 15px",
  };

  const overlayStyles = {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "-5",
    // backgroundColor: "rgba(0, 0, 0, 0.5)",
  };

  return (
    <>
      <div
        style={{
          display: isXs ? "none" : "flex",
          height: "60px",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
          padding: "0px 30px",
        }}
      >
        <Link to="/">
          <img
            style={{ zIndex: "10", height: "30px", Border: "1px solid red" }}
            src={fundnest_icon}
            alt="Fundnest logo"
          />
        </Link>
        <div onClick={toggleDrawer}>
          <MenuIcon />
        </div>
      </div>

      <div>
        <Slide direction="left" in={openNew} mountOnEnter unmountOnExit>
          <div
            style={{
              position: "fixed",
              top: "0",
              right: "0",
              width: "65%",
              height: "100vh",
              overflowY: "auto",
              backgroundColor: "white",
              borderLeft: "1px solid #ccc",
              boxShadow: "-2px 0px 5px rgba(0, 0, 0, 0.1)",
              padding: "0px",
              zIndex: 10,
            }}
          >
            <div style={{ marginTop: "40px", padding: "10px 15px" }}>
              <Link style={{ textDecoration: "none", color: "black" }} href="/">
                {t('navbar.menus', { returnObjects: true })[0]['name']}
              </Link>
            </div>
            <hr style={{ margin: "0px" }} />
            <div style={{ marginTop: "0px", padding: "10px 15px" }}>
              <Link
                style={{ textDecoration: "none", color: "black" }}
                href="/about-us"
              >
                {t('navbar.menus', { returnObjects: true })[1]['name']}
              </Link>
            </div>
            <hr style={{ margin: "0px" }} />
            <div style={mobileDropdownStyles}>
              <div
                style={{
                  color: "black",
                  textDecoration: "none",
                  // fontSize: "18px",
                  cursor: "pointer",
                }}
                onClick={toggleDropdown}
              >
                {t('navbar.menus', { returnObjects: true })[2]['name']}  <KeyboardArrowDownIcon />
              </div>

              <div
                style={{
                  display: isOpen ? "block" : "none",
                  // position: "absolute",
                  height: isOpen ? "auto" : "0px",
                  // marginTop: "13px",
                  backgroundColor: "#fff",
                  width: isXs ? "250px" : "auto",
                  zIndex: "999",
                  padding: "10px 15px",
                  borderRadius: "20px",
                }}
              >
                <div style={{ marginTop: "7px" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "black",
                      padding: "10px 0px",
                      fontSize: "14px",
                      lineHeight: "1.5",
                    }}
                    to="/services/it-staffing"
                  >
                    {t('navbar.menus', { returnObjects: true })[2]['dropdown'][0]['name']}
                  </Link>
                </div>
                <div style={{ marginTop: "7px" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "black",
                      padding: "10px 0px",
                      fontSize: "14px",
                    }}
                    to="/services/strategic-consulting"
                  >
                    {t('navbar.menus', { returnObjects: true })[2]['dropdown'][1]['name']}
                  </Link>
                </div>
                <div style={{ marginTop: "7px" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "black",
                      padding: "10px 0px",
                      fontSize: "14px",
                      lineHeight: "0px",
                    }}
                    to="/services/design-development"
                  >
                    {t('navbar.menus', { returnObjects: true })[2]['dropdown'][2]['name']}
                  </Link>
                </div>
                <div style={{ marginTop: "7px" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "black",
                      padding: "10px 0px",
                      fontSize: "14px",
                    }}
                    to="/services/digital-marketing"
                  >
                    {t('navbar.menus', { returnObjects: true })[2]['dropdown'][3]['name']}
                  </Link>
                </div>
                <div style={{ marginTop: "7px" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "black",
                      padding: "10px 0px",
                      fontSize: "14px",
                    }}
                    to="/services/cloud-solutions"
                  >
                    {t('navbar.menus', { returnObjects: true })[2]['dropdown'][4]['name']}
                  </Link>
                </div>
                <div style={{ marginTop: "7px" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "black",
                      padding: "10px 0px",
                      fontSize: "14px",
                    }}
                    to="/services/database-security"
                  >
                    {t('navbar.menus', { returnObjects: true })[2]['dropdown'][5]['name']}
                  </Link>
                </div>
              </div>

              {isOpen && (
                <div
                  style={overlayStyles}
                  onClick={() => setIsOpen(false)}
                ></div>
              )}
            </div>
            <hr style={{ margin: "0px" }} />
            <div style={{ marginTop: "5px", padding: "10px 15px" }}>
              <Link
                style={{ textDecoration: "none", color: "black" }}
                href="/contact-us"
              >
                {t('navbar.menus', { returnObjects: true })[3]['name']}
              </Link>
            </div>
            <hr style={{ margin: "0px" }} />
            <div style={{ margin: "10px 0px", padding: "10px 15px" }}>
              <Link
                style={{
                  textDecoration: "none",
                  fontSize: "16px",
                  borderRadius: "7px",
                  backgroundColor: "blue",
                  padding: "10px 15px",
                  color: "white",
                }}
                to="/get-a-quote"
              >
                {t('navbar.menus', { returnObjects: true })[4]['name']}
              </Link>
            </div>
            <hr style={{ margin: "0px" }} />
            <div className="language-selector dropdown border-warning" style={{ margin: "5px 0px", padding: "10px 15px" }} ref={dropdownRef}>
              <button
                style={{ padding: "0.7rem 0.9rem", width: 150, position: "relative" }}
                className="btn btn-sm btn-light dropdown- shadow-sm border rounded-pill d-flex align-items-center gap-3 position-reletive"
                type="button"
                onClick={toggleLanguageDropdown}
                aria-expanded={isLanOpen}
              >
                <img
                  src={`https://flagcdn.com/w20/${selectedLanguage.flag}.png`}
                  alt={selectedLanguage.name}
                  className="flag-icon"
                  height={12}
                />
                <KeyboardArrowDownIcon style={{ height: "15px", width: "20px", position: "absolute", right: 5 }} />
                <span>{selectedLanguage.name}</span>
              </button>
              <ul className={`dropdown-menu${isLanOpen ? " show " : ""}  end-25 top-100 `}>
                {languages.map((language) => (
                  <li key={language.code}>
                    <div
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleLanguageSelect(language);
                      }}
                    >
                      <img
                        src={`https://flagcdn.com/w20/${language.flag}.png`}
                        alt={language.name}
                        className="flag-icon me-2"
                      />
                      <span>{language.name}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* MUI Close button */}

            <CloseIcon
              onClick={toggleDrawer}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                color: "black", // You can customize the color here
              }}
            />
          </div>
        </Slide>
      </div>

      <nav
        style={{
          display: isXs ? "flex" : "none",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100px",
          color: "black",
          backgroundColor: "#EDFBF3",
          paddingLeft: "60px",
          paddingRight: "60px",
        }}
      >
        <div>
          <Link to="/">
            <img height={40} src={fundnest_icon} alt="Navlogo" />{" "}
          </Link>{" "}
        </div>
        <div style={{ display: "flex", gap: "40px" }}>
          <div>
            <Link
              to="/"
              style={{
                color: "black",
                textDecoration: "none",
                fontSize: "18px",
              }}
            >
              {t('navbar.menus', { returnObjects: true })[0]['name']}
            </Link>
          </div>
          <div>
            <Link
              to="/about-us"
              style={{
                color: "black",
                textDecoration: "none",
                fontSize: "18px",
              }}
            >
              {t('navbar.menus', { returnObjects: true })[1]['name']}
            </Link>
          </div>

          <div style={dropdownStyles}>
            <div
              style={{
                color: "black",
                textDecoration: "none",
                fontSize: "18px",
                cursor: "pointer",
              }}
              onClick={toggleDropdown}
            >
              {t('navbar.menus', { returnObjects: true })[2]['name']} <KeyboardArrowDownIcon />
            </div>

            <div
              style={{
                display: isOpen ? "block" : "none",
                position: "absolute",
                marginTop: "13px",
                backgroundColor: "#fff",
                width: "250px",
                zIndex: "10",
                padding: "15px 25px",
                borderRadius: "20px",
              }}
            >
              {/* <div style={{ marginTop: '7px' }}>
              <Link style={{ textDecoration: 'none', color: 'black' }} to="/services">All Services</Link>
            </div> */}
              <div>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to="/services/it-staffing"
                >
                  {t('navbar.menus', { returnObjects: true })[2]['dropdown'][0]['name']}
                </Link>
              </div>
              <div style={{ marginTop: "7px" }}>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to="/services/strategic-consulting"
                >
                  {t('navbar.menus', { returnObjects: true })[2]['dropdown'][1]['name']}
                </Link>
              </div>
              <div style={{ marginTop: "7px" }}>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to="/services/design-development"
                >
                  {t('navbar.menus', { returnObjects: true })[2]['dropdown'][2]['name']}
                </Link>
              </div>
              <div style={{ marginTop: "7px" }}>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to="/services/digital-marketing"
                >
                  {t('navbar.menus', { returnObjects: true })[2]['dropdown'][3]['name']}
                </Link>
              </div>
              <div style={{ marginTop: "7px" }}>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to="/services/cloud-solutions"
                >
                  {t('navbar.menus', { returnObjects: true })[2]['dropdown'][4]['name']}
                </Link>
              </div>
              <div style={{ marginTop: "7px" }}>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to="/services/database-security"
                >
                  {t('navbar.menus', { returnObjects: true })[2]['dropdown'][5]['name']}
                </Link>
              </div>
            </div>

            {isOpen && (
              <div style={overlayStyles} onClick={() => setIsOpen(false)}></div>
            )}
          </div>

          {/* <div><Link to="#contact" style={{ color: 'black', textDecoration: 'none', fontSize: '18px', }}>Careers</Link></div> */}
          {/* <div><Link to="#c" style={{ color: 'black', textDecoration: 'none', fontSize: '18px', }}>Blog</Link></div> */}
          <div>
            <Link
              to="/contact-us"
              style={{
                color: "black",
                textDecoration: "none",
                fontSize: "18px",
              }}
            >
              {t('navbar.menus', { returnObjects: true })[3]['name']}
            </Link>
          </div>
          <div>
            <Link
              to="/get-a-quote"
              style={{ marginTop: "-5px", }}
              className="btn btn-primary btn "
            >
              {t('navbar.menus', { returnObjects: true })[4]['name']}
            </Link>
          </div>
          <div className="language-selector dropdown" ref={dropdownRef}>
            <button
              style={{ padding: "0.6rem 0.7rem", width: "60px" }}
              className="btn btn-sm btn-light dropdown- shadow-sm border rounded-pill d-flex align-items-center justify-content-between position-reletive"
              type="button"
              onClick={toggleLanguageDropdown}
              aria-expanded={isLanOpen}
            >
              <img
                src={`https://flagcdn.com/w20/${selectedLanguage.flag}.png`}
                alt={selectedLanguage.name}
                className="flag-icon"
                height={12}
              />
              <KeyboardArrowDownIcon style={{ height: "15px", width: "20px", position: "absolute", right: 5 }} />
              {/* <span>{selectedLanguage.name}</span> */}
            </button>
            <ul className={`dropdown-menu${isLanOpen ? " show " : ""}  end-0 top-100 `}>
              {languages.map((language) => (
                <li key={language.code}>
                  <div
                    className="dropdown-item d-flex align-items-center"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLanguageSelect(language);
                    }}
                  >
                    <img
                      src={`https://flagcdn.com/w20/${language.flag}.png`}
                      alt={language.name}
                      className="flag-icon me-2"
                    />
                    <span>{language.name}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </nav>
    </>
  );
}

export default Navbar;
